"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const S3Client_1 = __importDefault(require("client/S3Client"));
const UploadClient_1 = require("client/UploadClient");
const getPresignUrl = (presignQuery) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield (0, UploadClient_1.getPerformancePreSignUrl)(presignQuery);
    if (data) {
        return data;
    }
});
const useS3Upload = () => {
    const [uploading, setUploading] = (0, react_1.useState)(false);
    const [presignUrl, setPresignUrl] = (0, react_1.useState)(null);
    const uploadFile = ({ file, presignQuery, onSuccess, onError }) => __awaiter(void 0, void 0, void 0, function* () {
        setUploading(true);
        const presignData = yield getPresignUrl(presignQuery);
        if (presignData) {
            setPresignUrl(presignData);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const { status } = (yield (0, S3Client_1.default)(presignData.uploadUrl, file));
            if (status === 200) {
                onSuccess && (yield onSuccess(presignData));
            }
            else {
                onError && (yield onError());
            }
        }
        setUploading(false);
    });
    return { uploading, presignUrl, uploadFile };
};
exports.default = useS3Upload;
